export default "__VITE_ASSET__CoCa2JN9__"